<app-template-upload [disabled]="disabled" [value]="value" [control]="control" [label]="label" />
